import { 
  FC, 
  // useState 
} from 'react';
import SignatureProcess from "../../../../SignatureProcess";

import {
  FormHelperText,
  // Select, InputLabel, FormControl, MenuItem, SelectChangeEvent,
  DialogActions, DialogContent, DialogTitle,
  Stack, Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import useNoSIPSCession from '@/components/Contracts/hooks/useNoCessionSIPS';
import { Button } from '@gisce/oficina-virtual-components';
import { ContractDisplayTypes } from '@/components/Contracts/types/contracts';

interface INoSIPSCessionDialogProps {
  contractName: string;
  isWaitingForSignature: boolean;
  type: ContractDisplayTypes;
  onDialogClose: () => void;
}

const NoSIPSCession: FC<INoSIPSCessionDialogProps> = ({
  contractName,
  isWaitingForSignature,
  type,
  onDialogClose
}) => {
  const { t } = useTranslation();
  
  const {
    errors,
    isSubmitting,
    handleSubmitNoSIPSCession
  } = useNoSIPSCession({
    contractName,
    type,
  });

  // const [noSIPSCessionSelection, setNoSIPSCessionSelection] = 
  //   useState<NoSIPSCessionSelection>("all");

  const handleClose = () => {
    onDialogClose();
  }

  const handleSend = () => {
    // handleSubmitNoSIPSCession(noSIPSCessionSelection);
    handleSubmitNoSIPSCession("actual");
  }

  // const handleChangeNoCessionSelection = (event: SelectChangeEvent) => {
  //   setNoSIPSCessionSelection(event.target.value as NoSIPSCessionSelection);
  // };

  return (
    <>
      <DialogTitle>
        {t('common:text.sips_title')}
      </DialogTitle>
      <DialogContent>
        {!isWaitingForSignature &&
          <Stack direction="column" spacing={2}>

            <Typography>
              {t('common:text.sips_description')}
            </Typography>

            {/* <FormControl>
              <InputLabel shrink htmlFor="">
                {t('common:text.sips_contracts')}
              </InputLabel>
              <Select
                onChange={handleChangeNoCessionSelection}
                value={noSIPSCessionSelection}
                disabled={isSubmitting}
                error={!!(errors?.noCessionSelection)}
              >
                <MenuItem key="all" value="all">
                  {t('common:text.sips_all')}
                </MenuItem>
                <MenuItem key="actual" value="actual">
                  {t('common:text.sips_current')}
                </MenuItem>
              </Select>
            </FormControl> */}

            {!!(errors?.noCessionSelection) &&
              <FormHelperText error={true}>
                {errors.noCessionSelection[0]}
              </FormHelperText>
            }
            
          </Stack>
        }

        {isWaitingForSignature && <SignatureProcess />}

      </DialogContent>
      
      <DialogActions sx={{display: "flex", justifyContent: "space-between"}}>
        <Button
          color={'primary'}
          variant={'outlined'}
          onClick={handleClose}
        >
          {t('common:text.sips_close')}
        </Button>

        {!isWaitingForSignature &&
          <Button
            color={'primary'}
            variant={'contained'}
            disabled={isSubmitting}
            loading={isSubmitting}
            onClick={handleSend}
          >
            {t('common:text.sips_send')}
          </Button>
        }
      </DialogActions>
    </>
  );
}

export default NoSIPSCession;